import { render, staticRenderFns } from "./CategoryDeleteDialog.vue?vue&type=template&id=1c6477b8&scoped=true"
import script from "./CategoryDeleteDialog.vue?vue&type=script&lang=js"
export * from "./CategoryDeleteDialog.vue?vue&type=script&lang=js"
import style0 from "./CategoryDeleteDialog.vue?vue&type=style&index=0&id=1c6477b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6477b8",
  null
  
)

export default component.exports